module.exports = __webpack_public_path__ + "static/media/CeraPro-Medium.2bdb9b4e.ttf";